/**
 * Rechtstexte und Kontaktwege - an einer Stelle.
 *
 * Sie liegen auf der Marketing-Seite und nicht in der App: eine zweite Fassung
 * in der App waere eine zweite Wahrheit, und zwar die, die niemand pflegt.
 */
/**
 * Die Schluessel heissen wie die Seiten auf der Website. Uebersetzt waeren sie
 * ein zweiter Name fuer dieselbe Seite - und beim naechsten Blick in die
 * Website muesste man ihn erst wieder zurueckuebersetzen.
 */
export const LEGAL_URLS = {
  agb: 'https://melowish.com/agb/',
  datenschutz: 'https://melowish.com/datenschutz/',
  impressum: 'https://melowish.com/impressum/',
} as const;

/** Wohin ein Widerruf geht. */
export const CONTACT_MAIL = 'info@melowish.com';
export const CONTACT_FORM = 'https://melowish.com/kontakt/';

/** Anbieter, wie er in Einwilligungen genannt wird. */
export const PROVIDER = 'edwaco eGbR, Boschstraße 1A, 30916 Isernhagen';
